import useGenericPageUrlQuery from "@gatsby-plugin-generic-page/hooks/useGenericPageUrlQuery"
import type { BreadcrumbItem } from "~/context/BreadcrumbsContext"

const ACRONYMS = new Set(["ai", "vps", "ssl"])

export function prettifyUrlSegment(segment: string): string {
  return segment
    .split("-")
    .map((word, index) => {
      if (ACRONYMS.has(word.toLowerCase())) {
        return word.toUpperCase()
      }

      return index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
    })
    .join(" ")
}

export type GenericPageBreadcrumbs = {
  items: BreadcrumbItem[]
  currentLabel?: string
}

export default function useGenericPageBreadcrumbs(
  url: string
): GenericPageBreadcrumbs {
  const pages = useGenericPageUrlQuery()
  const segments = url.split("/").filter(Boolean)
  const ancestorSegments = segments.slice(0, -1)
  const currentSegment = segments[segments.length - 1]

  const pageUrls = new Set(pages.map((page) => page.flatData.url))

  const items = ancestorSegments.map((segment, index) => {
    const segmentUrl = `/${ancestorSegments.slice(0, index + 1).join("/")}/`

    return {
      label: prettifyUrlSegment(segment),
      url: pageUrls.has(segmentUrl) ? segmentUrl : undefined,
    }
  })

  return {
    items,
    currentLabel: currentSegment
      ? prettifyUrlSegment(currentSegment)
      : undefined,
  }
}
